import { gridBreakPoints, largeScreen, smallScreen } from 'common/theme'
import { VehicleLoader } from 'modules/VehicleList/VehicleLoader'
import { Col, Row, Button, Tooltip } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledTitleSection = styled(Row)`
  h3 {
    color: #c3200f;

    &:hover {
      cursor: pointer;
      opacity: 0.5;
    }
  }

  a {
    font-size: 2.3rem !important;
  }
`

export const StyledVehicleDetailsCard = styled(VehicleLoader)`
  background-color: #fff;
  flex: 1;
  border: 0.1rem solid #ddd;
  padding: 1rem 1rem 1rem 1rem;
  margin-top: 0;
  margin-bottom: 1.6rem;
  min-height: 25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;

  > .row {
    column-gap: 1.5rem;
  }

  .vehicle-detail-image-section {
    min-width: 30rem;
    max-width: 30rem;
    @media (max-width: ${smallScreen}) {
      max-width: 40rem;
    }
    position: relative;

    .custom-control.custom-checkbox {
      position: absolute;
      margin: 0.5rem;
    }
    .nav-link {
      padding: 0;
    }

    .stockwave-light-bulb-container {
      margin-left: 4rem;
    }
  }

  .carfax-advanced-section {
    margin-top: 0.8rem;
    @media (max-width: ${smallScreen}) {
      padding-left: inherit;
    }
  }

  ${StyledTitleSection} {
    display: flex;
    align-items: center;
    padding: 0 1.5rem;
    margin: 0;

    a {
      padding: 0;
      font-size: 1.7rem;
      color: ${({ theme }) => theme.colors.InfinitiLinkColor};
      font-weight: 600;

      &:active,
      &:hover {
        color: ${({ theme }) => theme.colors.InfinitiLinkHoverColor};
      }
    }

    div[class^='col'] {
      padding-left: 0;
      padding-right: 0;
    }
    @media screen and (max-width: mediumScreen) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .link-col {
    color: ${({ theme }) => theme.colors.InfinitiLinkColor} !important;

    display: flex;
    align-items: center;
    gap: 1.2rem;

    a {
      text-decoration: none;
      font-size: 1.5rem;

      &:hover {
        cursor: pointer;
        color: ${({ theme }) => theme.colors.InfinitiLinkHoverColor};
      }
    }

    .icon {
      margin-right: 0.4rem;
    }
  }

  .vehicle-info {
    margin-bottom: 1rem;
    gap: 0.8rem 0;
    color: ${({ theme }) => theme.colors.headerFontColor};

    a {
      text-decoration: underline;
    }

    @media screen and (min-width: mediumScreen) {
      .vehicle-properties {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .true-frame-link {
    max-width: 8rem;

    &:empty {
      display: none;
    }
  }

  .carfax-link {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.linkColorLight};
    text-transform: uppercase;

    .icon {
      margin-right: 0;
    }
  }

  .vehicle-select {
    z-index: 11;
  }

  @media (max-width: ${gridBreakPoints.sm}) {
    .svfy_viewer {
      z-index: 2 !important;
    }
  }
`

export const StyledCarfaxCol = styled(Col)`
  display: flex;

  @media (max-width: ${largeScreen}) {
    width: 100%;
  }
`

export const StyledRibbonContainer = styled.div`
  & span:not(:last-child) .ribbon {
    margin-right: 1.5rem;
  }

  & span .ribbon {
    margin-left: 0;
  }

  .ribbon-title {
    filter: brightness(0.75);
  }
`

export const StyledInfoLabel = styled.span`
  font-weight: 700;
  margin-right: 0.375rem;
`
export const StyledToolTip = styled(Tooltip)`
  .arrow {
    display: none;
  }
  .tooltip-inner {
    background-color: #fff;
    color: black;
    border: 0.1rem solid #ddd;
    border-radius: 0.5rem;
    max-width: 30rem;
  }
`

export const VehicleVin = styled.div`
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.headerFontColor};
  margin-bottom: 0.2rem;
`

export const PaperClipButton = styled(Button)`
  margin-left: 1rem;

  .fa-paperclip {
    color: ${({ theme }) => theme.colors.primary};
  }
`
export const TitleVDP = styled.span`
  padding: 0;
  font-size: 2.3rem;
  color: ${({ theme }) => theme.colors.headerFontColor};

  margin-right: 0.8rem;
  font-weight: 600;
`

export const AnnouncementIcon = styled.div<{ assetFolder: string }>`
  background-image: ${({ assetFolder }) =>
    `url(/content/img/announcement-${assetFolder === 'Infiniti' ? 'infi' : 'nissan'}.png)`};
  width: 28px;
  height: 20px;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 20px;
`

export const VehicleNoteContainer = styled.div`
  align-items: center;
`

export const StyledVehicleProperties = styled.div`
  margin-top: 1.5rem;
  a {
    color: ${({ theme }) => theme.colors.InfinitiLinkColor} !important;
  }

  a:hover,
  a:active {
    color: ${({ theme }) => theme.colors.InfinitiLinkHoverColor} !important;
  }
`
